import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import SuccessScoringGroupService from "../../../../Domain/SuccessScoringGroup/SuccessScoringGroup.service";
import FeatureVisibilityWrapper from "../../Feature/FeatureVisibilityWrapper";
import { Features } from "../../../../Domain/Feature/Feature.model";
const getIndicatorClass = (group) => {
    const lowRiskClass = "text-success fa-check-circle";
    const mediumRiskClass = "text-warning fa-minus-circle";
    const highRiskClass = "text-danger fa-exclamation-circle";
    const unknownClass = "text-muted fa-question-circle";
    if (!group) {
        return unknownClass;
    }
    switch (group.id && group.id.toString()) {
        case SuccessScoringGroupService.HighId.toString():
            return highRiskClass;
        case SuccessScoringGroupService.MediumId.toString():
            return mediumRiskClass;
        case SuccessScoringGroupService.LowId.toString():
            return lowRiskClass;
        default:
            return unknownClass;
    }
};
/**
 * Displays the term success score and course success score
 */
const SuccessIndicators = (props) => {
    const showCourseIndicator = props.hasPermissionForCourseSuccessScore &&
        (props.hasPermissionForTermSuccessScore || !!props.courseSuccessScore);
    const showTermIndicator = props.hasPermissionForTermSuccessScore &&
        (props.hasPermissionForCourseSuccessScore || !!props.termSuccessScore);
    if (!props.courseSuccessScore && !props.termSuccessScore) {
        return null;
    }
    return showCourseIndicator || showTermIndicator ? (_jsxs("div", { className: "d-flex justify-content-around pt-1", children: [showTermIndicator && (_jsx(FeatureVisibilityWrapper, { name: Features.INDICATORS_PERSISTENCE_RISK_INDICATOR, children: _jsx("span", { className: `fa ${getIndicatorClass(props.termSuccessScore)}`, title: `Term Persistence: ${props.termSuccessScore
                        ? props.termSuccessScore.name
                        : "No Persistence Risk Score for this student. Contact your Aviso administrator for more details."}` }) })), showCourseIndicator && (_jsx(FeatureVisibilityWrapper, { name: Features.INDICATORS_COURSE_RISK_INDICATOR, children: _jsx("span", { className: `fa ${getIndicatorClass(props.courseSuccessScore)}`, title: `Course Completion: ${props.courseSuccessScore
                        ? props.courseSuccessScore.name
                        : "No Course Completion Risk Score for this student. Contact your Aviso administrator for more details."}` }) }))] })) : null;
};
export default SuccessIndicators;
